type RequestingOtpError = 'local-user-not-found';
type VerifyingOtpError = 'bad-credentials' | 'expired' | 'rate-limited';
export type LoginError =
  | RequestingOtpError
  | VerifyingOtpError
  | 'generic-error';

type LoginStateData =
  | {
      type: 'REQUESTING_OTP';
      phoneNumber: string;
      error?: RequestingOtpError | 'generic-error';
    }
  | {
      type: 'VERIFYING_OTP';
      phoneNumber: string;
      error?: VerifyingOtpError | 'generic-error';
    }
  | {
      type: 'VERIFYING_OTP_SUCCESS';
      phoneNumber: string;
    };

export type LoginState = {
  data: LoginStateData;
  loading: boolean;
};

export type LoginAction = 'LOADING' | LoginStateData;

export const loginReducer = (
  state: LoginState,
  action: LoginAction,
): LoginState => {
  if (action === 'LOADING') {
    return { ...state, loading: true };
  } else {
    return { data: action, loading: false };
  }
};
